const smartBar = {
  more: "More",
  overflow: "More widgets",
  lockWidget: "Lock widget",
  unlockWidget: "Unlock widget",
  pinnedSettings: "Settings",
  pinnedStore: "Widget Store",
  searchShortcuts: "Search...",
  barSettings: "Bar Settings",
  widgetSettings: "Widget Settings",
  info: "Info",
  customIcon: "Custom Icon",
  defaultSize: "Default Size",
  category: "Category",
  status: "Status",
} as const;
export default smartBar;
